/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDetailsDtoApiResponse } from '../../models/user-details-dto-api-response';

export interface GetUserAsync$Params {
  id: number;
}

export function getUserAsync(http: HttpClient, rootUrl: string, params: GetUserAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserAsync.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDetailsDtoApiResponse>;
    })
  );
}

getUserAsync.PATH = '/api/user/{id}';
